import { Directive } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: "[trim]",
    host: {
        '(input)': "trimValueCase($event.target.value)"
    }

})
export class TrimValueDirective {
    constructor(private readonly control: NgControl) {
    }
    // ReSharper disable once TsResolvedFromInaccessibleModule
    trimValueCase(value: string) {
        //this.ref.nativeElement.value = value.replace(/^\s*(.*)\s*$/, "$1");
        const valueToTransform = value.replace(/^\s*(.*)\s*$/, "$1");
        // do something with the valueToTransform
        this.control.control.setValue(valueToTransform);
    }
}